import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserComponent} from './user.component';
import {ComponentsModule} from '../../../components/components.module';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {UserEditComponent} from './user-edit/user-edit.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {ToastModule} from 'primeng/toast';
import {DividerModule} from 'primeng/divider';
import {InputMaskModule} from 'primeng/inputmask';
import {ButtonModule} from 'primeng/button';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from "@ngx-translate/core";
import { PipesModule } from '../../../pipes/pipes.module';


@NgModule({
    declarations: [UserComponent, UserEditComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        TableModule,
        TagModule,
        DialogModule,
        ConfirmDialogModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        InputTextModule,
        MultiSelectModule,
        DropdownModule,
        CheckboxModule,
        ToastModule,
        DividerModule,
        InputMaskModule,
        ButtonModule,
        SelectButtonModule,
        TooltipModule,
        TranslateModule,
        PipesModule
    ],
    exports: [UserComponent, UserEditComponent]
})
export class UserModule { }
